import type { IProps } from "./interfaces"

import classes from "./styles.module.css"

/**
 * SharedDocumentFrame — sandboxed viewport for a publicly shared, backend-rendered
 * document (a meeting summary or a visual report).
 *
 * SECURITY: the document is injected via `srcdoc` into an iframe sandboxed with
 * ONLY `allow-scripts` — no `allow-same-origin` (opaque origin: it can never read
 * the app's cookies, storage, or DOM) and deliberately no `allow-popups` (a
 * report body is LLM/transcript-derived, so denying window.open removes the
 * phishing/exfil-via-new-tab vector). `allow-scripts` lets the backend's own
 * nonced Mermaid runtime draw diagrams; the document also carries its OWN nonce
 * `<meta>` Content-Security-Policy (`default-src 'none'; script-src 'nonce-…'`),
 * so only that runtime executes and nothing can reach the network.
 *
 * Dumb: the sealed `html` string and `title` arrive as props; the route fetches them.
 */
export const SharedDocumentFrame = ({ html, title }: IProps): React.JSX.Element => {
  return <iframe srcDoc={html} title={title} sandbox="allow-scripts" className={classes.frame} />
}
